/**
 * Token Manager
 * Provides a centralized way to manage authentication tokens
 * without polluting the window object
 */

let authToken = null;

export const setAuthToken = (token) => {
  authToken = token;
};

export const getAuthToken = () => {
  return authToken;
};

export const clearAuthToken = () => {
  authToken = null;
};
